import { render } from "./ModalMaster.vue?vue&type=template&id=75bee0a0"
import script from "./ModalMaster.vue?vue&type=script&lang=js"
export * from "./ModalMaster.vue?vue&type=script&lang=js"

import exportComponent from "F:\\work\\1\\s\\vue-code\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__